import cx from 'classnames';
import {type FC, useState} from 'react';
import {shallowEqual, useSelector} from 'react-redux';
import {selectGalleryData} from '~/GalleryPB/reducers/galleryData';
import type {Relative} from '~/GalleryPB/types/gallery';
import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';
import {useMatchQuery} from '~library/hooks/useMatchQuery';
import {largishAndUp} from '~libSass/base/_exports.sass';

import * as styles from './SubCategories.module.scss';

interface SubCategoriesProps {
  group: Relative[];
}

export const SubCategories: FC<SubCategoriesProps> = ({group}) => {
  const MAX_DEFAULT_CATEGORIES_SHOWN = 5;

  const activeSubCategory = window.location.pathname.slice(1).split('/')[2];

  const {matches: largeScreens} = useMatchQuery(`(min-width: ${largishAndUp})`);
  const {breadcrumbs, categoryPath, hasChildren, parentId} = useSelector(
    selectGalleryData,
    shallowEqual
  );

  const [seeMore, setSeeMore] = useState(false);

  const mountCategoryHref = (currentCategoryPath: string) => {
    // get the current path from the last level of the breadcrumb
    const pathname = breadcrumbs?.slice(-1)[0]?.href;
    // just add the current category path if it's not in the higher hierarchy level (no parents)
    // to avoid duplicates, and if it's not int the lower level (no children)
    const parentCategoryPath = hasChildren && parentId ? `${categoryPath}/` : '';
    return `${pathname}/${parentCategoryPath}${currentCategoryPath}/?filter=${
      window.cards_page ? 'card' : 'invitation'
    }`;
  };

  return group.length > 0 ? (
    <ul className={styles.subcategoryList} id="gallery-subcategories">
      {group.map((category, index) => {
        if (!largeScreens || seeMore || index < MAX_DEFAULT_CATEGORIES_SHOWN) {
          return (
            <li
              className={styles.subcategoryItem}
              key={category.categoryId}
              data-qa-id="gallery_subcategoryWrapper"
            >
              <a
                className={cx(styles.subcategoryLabel, {
                  [styles.active]: activeSubCategory === category.categoryId,
                })}
                data-qa-id={`gallery_subcategory__${category.categoryId}--${category.categoryId}_link`}
                href={mountCategoryHref(category.categoryPath)}
              >
                {category.displayName}
              </a>
            </li>
          );
        }
      })}
      {largeScreens && group.length > MAX_DEFAULT_CATEGORIES_SHOWN && !seeMore && (
        <Button
          onClick={() => setSeeMore(true)}
          variant="unstyled-button"
          className={cx(styles.subcategoryLabel, styles.subcategorySeeMoreButton)}
          data-qa-id="gallery_subCategory_ShowMoreButton"
        >
          <Typography variant="paragraph3">See more</Typography>
        </Button>
      )}
    </ul>
  ) : null;
};
